import React, { useState, useEffect, useMemo } from "react";
import classNames from "classnames";
import dayjs from "dayjs";
import moment from "moment";
import AddItemButton from "ManagementTeam/Shared/AddItemButton";
import ObjectSelect from "../../Shared/ObjectSelect";
import { Dashboard } from "../../DashboardPage/useDashboard";
import { BlobProvider } from "@react-pdf/renderer";
import AgendaPdf from "../AgendaPdf";
import styles from "./Agenda.module.css";
import Auth from "../../../shared/@auth";
import { useDocuments } from "ManagementTeam/DocumentsPage/useDocuments";
import { AgendaBody } from "./AgendaBody/AgendaBody";
import { useSettings } from "ManagementTeam/SettingsPage/useSettings";
import { getNameOfTwoDaysMeeting } from "ManagementTeam/utils/meetingDateParse";
import { getPdfFutureMeeting } from "../../utils/getPdfFutureMeeting";
import Loader from "shared/Loader";

export function Agenda({
  agendas,
  itemOwners,
  status,
  futureMeetingsForEC,
  setIsModalOpen,
  readOnly = false,
  meetingType,
  isHideInfo,
}) {
  const { data: settings, getSettings } = useSettings(new Date().getFullYear());
  const { unassignedRefetch } = useDocuments();
  const { refetchDashboard } = Dashboard.useContainer();
  const { account } = Auth.useContainer();
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [currentMeetingDate, setCurrentMeetingDate] = useState(null);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [meetings, setMeetings] = useState(null);
  const [currentAgendaItems, setCurrentAgendaItems] = useState(null);
  const [currentMeetingIndex, setCurrentMeetingIndex] = useState(0);
  const [pdfMeetings, setPdfMeetings] = useState([]);
  const [pdfAgendas, setPdfAgendas] = useState([]);
  const [attendanceItem, setAttendanceItem] = useState(null);

  const handleFetchData = async () => {
    const currentYear = new Date().getFullYear();
    await getSettings(currentYear);
  };
  useEffect(() => {
    handleFetchData();
  }, []);
  useMemo(() => {
    agendas &&
      agendas.length > 0 &&
      setMeetings(
        agendas.sort(
          (a, b) =>
            new Date(a.dates[0].startsOn) - new Date(b.dates[0].startsOn)
        )
      );
  }, [agendas]);

  // set default meeting
  useMemo(() => {
    meetings &&
      meetings.length > 0 &&
      setCurrentMeeting(meetings[currentMeetingIndex]);
  }, [meetings, currentMeetingIndex]);

  // pdf meetings
  useMemo(() => {
    setPdfMeetings([]);
    const _meetings = (meetings || []).map((a) => getPdfFutureMeeting(a));
    setPdfMeetings(_meetings);
  }, [meetings]);

  // set default agenda items
  useMemo(() => {
    if (currentMeeting && settings) {
      var _agendas = [];
      currentMeeting.agenda.map((agendaItem) => {
        if (agendaItem.id) {
          _agendas.push(agendaItem);
        }
      });
      setCurrentAgendaItems(_agendas);
      const indexEnded = currentMeeting?.dates
        ? currentMeeting.dates.findIndex((date) => date.sessionEnded) + 1
        : 0;
      setAttendanceItem({
        attendees: currentMeeting.dates[indexEnded].attendees,
        guestAttendees: currentMeeting.dates[indexEnded].guests,
        users: currentMeeting.users,
        quorum: settings?.quorum || 0,
        meetingDate: currentMeeting.dates,
        meetingLocation: currentMeeting.inPerson
          ? currentMeeting.inPerson
          : null,
        meetingType: currentMeeting.meetingType,
      });
    }
  }, [currentMeeting, settings]);
  // agenda pdf
  useMemo(() => {
    if (currentMeeting && currentAgendaItems) {
      const email = account.username;
      setPdfAgendas([]);
      let userId = "";

      if (agendas !== undefined) {
        const i = currentMeeting.users.findIndex(
          (e) => e.profile.email !== undefined && e.profile.email === email
        );

        if (i > -1) {
          userId = currentMeeting.users[i]._id;
        }

        if (userId) {
          currentAgendaItems.map((i, index) => {
            if (i.id) {
              var yesVote = 0;
              var noVote = 0;
              setPdfAgendas((prev) => [
                ...prev,
                {
                  assignee: i.owner.name,
                  assignedType:
                    i.owner.name?.toUpperCase().includes("PAUL TSIKA") ||
                    i.owner.name?.includes("Attorneys")
                      ? "Attorney"
                      : i.owner.name.includes("WWG") ||
                        i.owner.name.includes("WWG Guest")
                      ? "WWG"
                      : "Diamond",
                  title: i.title,
                  pdfName:
                    i.document &&
                    i.document?.files &&
                    i.document?.files.length > 0
                      ? `${i.document.files[0].name}.${i.document.files[0].type}`
                      : "",
                  description: i?.description ? i?.description : "",
                  isNew: false,
                  isCompleted: i.isComplete,
                  hasChoices:
                    i.decision &&
                    i.decision?.choices &&
                    i.decision?.choices?.length > 0,
                  votingStatus:
                    i.decision?.status === "on"
                      ? "Voting in Progress"
                      : i.decision?.status === "off"
                      ? "Upcoming"
                      : i.decision?.votingStatus,
                  isAttendanceAgenda: i.isAttendanceAgenda,
                  isDraft: i.isDraft,
                },
              ]);
              return index;
            }
          });
        }
      }
    }
  }, [currentMeeting, agendas, account, currentAgendaItems]);

  const [meetingDates, setMeetingDates] = useState([]);
  // get meeting ids and dates
  useMemo(() => {
    var agendaSelect = [];
    meetings &&
      meetings.length > 0 &&
      meetings.map((meeting) => {
        let dateString =
          meeting.dates.length > 0
            ? meeting.dates.map((date) =>
                moment.utc(date.startsOn).format("MMMM DD, YYYY")
              )
            : [];

        var meetingDatesArray =
          meeting.dates.length > 0
            ? meeting.dates.map((date) =>
                moment.utc(date.startsOn).format("MMMM DD, YYYY")
              )
            : [];

        return agendaSelect.push({
          id: meeting._id,
          option:
            dateString.length === 2
              ? getNameOfTwoDaysMeeting(dateString)
              : dateString[0],
          dates: meetingDatesArray,
        });
      });
    setMeetingDates(agendaSelect);
  }, [meetings]);

  // set initial select option
  useMemo(() => {
    if (meetings && meetingDates.length > 0) {
      setCurrentMeetingDate(meetingDates[currentMeetingIndex]);
    }
  }, [meetings, meetingDates, currentMeetingIndex]);

  const handleSelectChange = (e) => {
    var index = 0;
    meetingDates.map((meeting, i) => {
      if (meeting.id === e) {
        index = i;
      }
      return null;
    });
    setCurrentMeetingDate(meetingDates[index]);
    setCurrentMeeting(agendas.find((meeting) => meeting._id === e));
    setCurrentMeetingIndex(index);
  };

  return status === "loading" ? (
    <div className={styles.noAgendas}>
      <Loader />
    </div>
  ) : (
    <div className={classNames(styles.container)}>
      <div className={styles.subHeader}>
        <span className={styles.meetingDatesDropdown}>
          {currentMeetingDate !== null ? (
            <ObjectSelect
              options={meetingDates}
              onChange={(e) => {
                handleSelectChange(e);
                refetchDashboard();
              }}
              placeholder={currentMeetingDate.option}
              selectedOption={currentMeetingDate}
              className={styles.dateSelect}
              isDateOption={true}
            />
          ) : null}
        </span>
        <span
          style={{ visibility: !readOnly ? "visible" : "hidden" }}
          className={styles.addButton}
        >
          <AddItemButton
            onClick={() => {
              setShowAddNewModal(true);
              setIsModalOpen(true);
              unassignedRefetch();
            }}
          />
          <div className={styles.addItemButtonText}>ADD AGENDA ITEM</div>
        </span>
        {currentAgendaItems &&
        currentAgendaItems.length > 0 &&
        currentMeetingDate !== null ? (
          <span className={styles.buttonContainer}>
            <BlobProvider
              document={
                <AgendaPdf
                  currentMeetingDate={currentMeetingDate}
                  currentMeetingInfo={currentMeeting}
                  date={currentMeetingDate.option}
                  agendaItems={pdfAgendas}
                  futureMeetings={pdfMeetings}
                  futureMeetingsForEC={futureMeetingsForEC}
                  isArchived={false}
                  meetingType={meetingType}
                />
              }
              fileName={`${dayjs().format("MM_DD_YYYY")} Agenda`}
            >
              {({ blob, url, loading, error }) => (
                <div className={styles.saveButton}>
                  {loading ? (
                    <div style={{ cursor: "progress" }}>
                      <span>Save Agenda as PDF</span>
                    </div>
                  ) : (
                    <a href={url} target="_blank" rel="noreferrer">
                      <span>Save Agenda as PDF</span>
                    </a>
                  )}
                </div>
              )}
            </BlobProvider>
          </span>
        ) : (
          <span className={styles.spacer} />
        )}
      </div>
      <span className={styles.divider} />
      <AgendaBody
        agendas={currentAgendaItems}
        itemOwners={itemOwners}
        status={status}
        setIsModalOpen={setIsModalOpen}
        meetingId={currentMeeting ? currentMeeting._id : null}
        meetingType={meetingType}
        users={meetings && meetings.length > 0 ? meetings[0].users : []}
        readOnly={readOnly}
        meetingDateOptions={meetingDates}
        showAddNewModal={showAddNewModal}
        setShowAddNewModal={setShowAddNewModal}
        // Using these fields for generating PDF
        attendanceItem={attendanceItem}
        type="agenda"
        isHideInfo={isHideInfo}
      />
    </div>
  );
}
